import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TopbarComponent, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ploggit-website';
  showSidebar: boolean = true; // Controla a visibilidade da sidebar

  constructor(
    private translate: TranslateService,
    private router: Router) {

    this.translate.use('pt').subscribe({
      next: () => console.log('Language set to PT successfully'),
      error: (err) => console.error('Error loading translations:', err)
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {

        const hiddenRoutes = [
          '/login',
          '/register',
          '/recover/password',
          '/about',
          '/home',
          '/conceito',
          '/comunidade',
          '/parcerias',
          '/equipas',
          '/eventos',
          '/amigos',
          '/classificacao',
          '/privacy-policy',
          '/terms-of-service'
        ];

        this.showSidebar =
          !hiddenRoutes.some(route =>
            event.urlAfterRedirects.startsWith(route)
          );
      });
  }
}